<template>
  <div class="@container">
    <div class="grid grid-cols-1 gap-4 @3xl:grid-cols-2">
      <SelectQuestionSection
        v-model="inputData.strengthIds"
        :all-questions="allQuestionsSorted('strength')"
        :topic-perspectives="topicPerspectives"
        :scale="scale"
        :title="$t('dialog.evaluation.slide.strengths')"
      />
      <SelectQuestionSection
        v-model="inputData.potentialIds"
        :all-questions="allQuestionsSorted('potential')"
        :topic-perspectives="topicPerspectives"
        :scale="scale"
        :title="$t('dialog.evaluation.slide.potentials')"
      />

      <template v-if="includeBlindSpots">
        <SelectQuestionSection
          v-model="inputData.overestimateIds"
          :all-questions="allQuestionsSorted('blindspot')"
          :topic-perspectives="topicPerspectives"
          :scale="scale"
          :title="$t('dialog.evaluation.slide.overestimates')"
        />
        <SelectQuestionSection
          v-model="inputData.underestimateIds"
          :all-questions="allQuestionsSorted('hiddenStrength')"
          :topic-perspectives="topicPerspectives"
          :scale="scale"
          :title="$t('dialog.evaluation.slide.underestimates')"
        />
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import SelectQuestionSection from './SelectQuestionSection.vue'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import { useQuestionAnalysisNew } from '@/core/composables/use-question-analysis-new'

  interface Props {
    questions: ReadonlyArray<QuestionAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
    inputData: {
      slideId: string
      overestimateIds: string[]
      potentialIds: string[]
      strengthIds: string[]
      underestimateIds: string[]
      textIds: string[]
    }
    includeBlindSpots: boolean
    scale: ReadonlyArray<{ value: number; label: string }>
  }
  const props = defineProps<Props>()

  const questions = computed(() => props.questions)

  const { allQuestionsSorted } = useQuestionAnalysisNew(questions, true, 'all')
</script>
